(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/hover-overlay.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/hover-overlay.js');
"use strict";


const Button = svs.ui.ReactButton;
const HoverOverlay = _ref => {
  let show = _ref.show;
  return React.createElement("div", {
    className: ['bingo-card-hover-overlay', show ? 'bingo-card-hover-overlay--visible' : ''].join(' ')
  }, React.createElement(Button, {
    className: "bingo-card-hover-overlay__start-btn",
    tabIndex: -1,
    transparent: true
  }, "Spela"));
};
setGlobal('svs.bingo_react.components.bingoCard.HoverOverlay', HoverOverlay);

 })(window);